import { useEffect, useState } from "react";
import { addTransfer } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";

export default function TransferForm(){

  const [accounts,setAccounts]=useState([]);
  const [errors, setErrors] = useState({});

  const [form,setForm]=useState({
    fromAccountId:"",
    toAccountId:"",
    amount:"",
    date:"",
    description:""
  });

  useEffect(()=>{ load(); },[]);

  const formatAccountLabel = (account)=>{
    const name = account?.accountName || "Account";
    const accountNumber = account?.accountNumber ? String(account.accountNumber) : "";
    const last4 = accountNumber ? accountNumber.slice(-4) : "";
    const numberLabel = last4 ? `****${last4}` : "";
    const balanceValue = account?.currentBalance;
    const balance =
      balanceValue !== null && balanceValue !== undefined && !Number.isNaN(Number(balanceValue))
        ? `₹${Number(balanceValue).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        : "";
    return [name, numberLabel, balance].filter(Boolean).join(" • ");
  };

  const load = async ()=>{
    setAccounts(await getAllAccounts());
  };

  const validate = (nextForm)=>{
    const nextErrors = {};
    if (!nextForm.fromAccountId) nextErrors.fromAccountId = "Select the source account.";
    if (!nextForm.toAccountId) nextErrors.toAccountId = "Select the destination account.";
    if (nextForm.fromAccountId && nextForm.toAccountId && nextForm.fromAccountId === nextForm.toAccountId) {
      nextErrors.toAccountId = "Choose a different destination account.";
    }
    const amount = parseFloat(nextForm.amount);
    if (!nextForm.amount || Number.isNaN(amount) || amount <= 0) nextErrors.amount = "Enter a valid amount.";
    if (!nextForm.date) nextErrors.date = "Select a date.";
    return nextErrors;
  };

  const updateField = (field, value)=>{
    setForm(f=>({ ...f, [field]: value }));
    if (errors[field] || (field === "fromAccountId" && errors.toAccountId)) {
      setErrors(e=>({
        ...e,
        [field]: undefined,
        ...(field === "fromAccountId" ? { toAccountId: undefined } : {})
      }));
    }
  };

  const readErrorMessage = async (res, fallback)=>{
    if (!res) return fallback;
    try {
      const data = await res.clone().json();
      if (typeof data === "string" && data) return data;
      if (data?.message) return data.message;
      if (data?.error) return data.error;
    } catch {}
    try {
      const text = await res.text();
      if (text) return text;
    } catch {}
    return fallback;
  };

  const submit = async (e)=>{
    e.preventDefault();
    const nextErrors = validate(form);
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }
    try {
      const res = await addTransfer(form);
      if (!res.ok) {
        const message = await readErrorMessage(res, "Transfer failed.");
        alert(message);
        return;
      }
      alert("Transfer successful");
    } catch (err) {
      alert(err?.message || "Transfer failed.");
    }
  };

  return (
    <form className="stack-form" onSubmit={submit}>
      <h3>Transfer</h3>

      <div className="transaction-field">
        <select
          className={errors.fromAccountId ? "transaction-input-error" : ""}
          onChange={e=>updateField("fromAccountId", e.target.value)}
          aria-invalid={Boolean(errors.fromAccountId)}
          required
        >
          <option value="">From Account</option>
          {accounts.map(a=><option key={a.id} value={a.id}>{formatAccountLabel(a)}</option>)}
        </select>
        {errors.fromAccountId && <div className="transaction-error-text">{errors.fromAccountId}</div>}
      </div>

      <div className="transaction-field">
        <select
          className={errors.toAccountId ? "transaction-input-error" : ""}
          onChange={e=>updateField("toAccountId", e.target.value)}
          aria-invalid={Boolean(errors.toAccountId)}
          required
        >
          <option value="">To Account</option>
          {accounts.map(a=><option key={a.id} value={a.id}>{formatAccountLabel(a)}</option>)}
        </select>
        {errors.toAccountId && <div className="transaction-error-text">{errors.toAccountId}</div>}
      </div>

      <div className="transaction-field">
        <input
          className={errors.amount ? "transaction-input-error" : ""}
          type="number"
          step="0.01"
          min="0.01"
          inputMode="decimal"
          placeholder="Amount"
          onChange={e=>updateField("amount", e.target.value)}
          aria-invalid={Boolean(errors.amount)}
          required
        />
        {errors.amount && <div className="transaction-error-text">{errors.amount}</div>}
      </div>

      <div className="transaction-field">
        <input
          className={errors.date ? "transaction-input-error" : ""}
          type="date"
          onChange={e=>updateField("date", e.target.value)}
          aria-invalid={Boolean(errors.date)}
          required
        />
        {errors.date && <div className="transaction-error-text">{errors.date}</div>}
      </div>

      <div className="transaction-field">
        <textarea placeholder="Description"
          onChange={e=>updateField("description", e.target.value)} />
      </div>

      <button className="btn btn-primary" type="submit">Transfer</button>
    </form>
  );
}
